module.exports = __webpack_public_path__ + "vue-dist/img/bind-card-passed.d168d560.png";